import styled from "styled-components";
import { Button } from "antd";
import colors from "frontend/src/constants/colors";

export const HallOfFameStyle = styled(Button)`
  padding: 0;

  span {
    color: ${colors.textGray};
    transition: color 0.2s ease;
  }

  &:hover {
  }

  &:hover span {
    color: ${colors.secondary};
  }
`;
